import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('lines'),
    accountColumnName: defineMessage('account'),
    debitAmountColumnName: defineMessage('debit_amount'),
    creditAmountColumnName: defineMessage('credit_amount'),
    taxCodeColumnName: defineMessage('tax_code'),
    taxRateColumnName: defineMessage('tax_rate'),
    taxAmountColumnName: defineMessage('tax_amount'),
    grossAmountColumnName: defineMessage('gross_amount'),
    taxAccountColumnName: defineMessage('tax_account'),
    memoColumnName: defineMessage('memo'),
    departmentColumnName: defineMessage('department'),
    classColumnName: defineMessage('class'),
    locationColumnName: defineMessage('location'),
    entityColumnName: defineMessage('entity'),
    amortizationScheduleColumnName: defineMessage('amortization_schedule_1'),
    amortizationStartDateColumnName: defineMessage('amortization_start_date_1'),
    amortizationEndDateColumnName: defineMessage('amortization_end_date_1'),
    amortizationResidualColumnName: defineMessage('amortization_residual_1'),
};
